import { Buffer } from 'buffer';
import process from 'process';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import './styles/global.css';

// Web3Auth + several of its transitive deps reach for `Buffer` and
// `process` as if running in Node.js. The browser has neither, so we
// polyfill them on `globalThis` before anything else loads. Failing
// to do this surfaces as the legendary "Can't find variable: Buffer"
// at first login click.
if (typeof globalThis.Buffer === 'undefined') {
  (globalThis as { Buffer?: typeof Buffer }).Buffer = Buffer;
}
if (typeof globalThis.process === 'undefined') {
  (globalThis as { process?: typeof process }).process = process;
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('Crypto-pay widget: #root element not found');
}

// Last-resort visibility: surface uncaught errors on the page console
// so devtools / Sentry can pick them up — without this a Web3Auth
// module-evaluation crash leaves a blank screen with no breadcrumbs.
window.addEventListener('error', (e) => {
  // eslint-disable-next-line no-console
  console.error('[Crypto-pay widget] window error:', e.error || e.message);
});
window.addEventListener('unhandledrejection', (e) => {
  // eslint-disable-next-line no-console
  console.error('[Crypto-pay widget] unhandled rejection:', e.reason);
});

try {
  createRoot(root).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
} catch (err) {
  // If even createRoot throws (e.g. React 18+ vs React 17 mismatch in
  // CDN-loaded bundles), paint the error directly so the page is not
  // black.
  root.innerHTML = `
    <div style="max-width:560px;margin:40px auto;padding:20px;border-radius:12px;
                background:#1f1217;color:#fda4af;border:1px solid #be123c;
                font-family:system-ui,sans-serif;font-size:14px;line-height:1.5;">
      <h2 style="margin:0 0 12px;font-size:16px;color:#fecaca;">
        Crypto-pay widget could not bootstrap React
      </h2>
      <p style="margin:0 0 8px;">
        <code>${(err as Error)?.message ?? String(err)}</code>
      </p>
    </div>
  `;
}
